export const LegacyBoardGate = 'Tasks:LegacyBoardAccess';